module.exports = __webpack_public_path__ + "img/slider2.681c203.jpg";